import {
  CarOutlined,
  KeyOutlined,
  LineChartOutlined,
  SettingOutlined,
  ShopOutlined,
  // ShoppingCartOutlined,
  UserOutlined
} from '@ant-design/icons';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import usePermissions from 'src/configs/auth';
import Permissions from 'src/configs/auth/permissions';
import { ROUTES } from 'src/constants/routes';
import useUserLogged from 'src/hooks/useUserLogged';
import { getAuth } from 'src/redux/slices/auth';

type Props = {
  setCollapsed: (c: boolean) => void;
  setMobileSidebar: (c: boolean) => void;
}
const useLinks = ({
  setCollapsed,
  setMobileSidebar
}: Props) => {
  const { t } = useTranslation();
  const { hasPermission, hasAccountPermission } = usePermissions();
  const navigate = useNavigate();
  const auth = useSelector(getAuth);
  const { isSuperAdminOnlyLogged } = useUserLogged();

  const links: any[] = [];

  if (auth.currentUser) {
    links.push({
      key: ROUTES.INVENTORY,
      icon: <CarOutlined />,
      onClick: () => {
        navigate(ROUTES.INVENTORY);
        setCollapsed(true);
        setMobileSidebar(false);
      },
      label: t('layout:inventory')
    });

    if (hasAccountPermission('contacts')) {
      links.splice(1, 0, {
        key: ROUTES.CONTACTS,
        icon: <UserOutlined />,
        onClick: () => {
          navigate(ROUTES.CONTACTS);
          setCollapsed(true);
          setMobileSidebar(false);
        },
        label: t('layout:contacts')
      });
    }

    // links.push({
    //   key: ROUTES.DEALS,
    //   icon: <ShoppingCartOutlined />,
    //   onClick: () => {
    //     navigate(ROUTES.DEALS);
    //     setCollapsed(true);
    //     setMobileSidebar(false);
    //   },
    //   label: t('layout:deals')
    // });

    links.push({
      key: ROUTES.PROFILE,
      icon: <SettingOutlined />,
      onClick: () => {
        navigate(ROUTES.PROFILE);
        setCollapsed(true);
        setMobileSidebar(false);
      },
      label: t('layout:profile')
    });

    links.push({
      key: ROUTES.ANALYTICS,
      icon: <LineChartOutlined />,
      onClick: () => {
        navigate(ROUTES.ANALYTICS);
        setCollapsed(true);
        setMobileSidebar(false);
      },
      label: t('layout:analytics')
    });

    if (hasPermission(Permissions.ACCESS_SCREEN_ACCOUNT)) {
      links.push({
        key: ROUTES.ACCOUNT,
        icon: <ShopOutlined />,
        onClick: () => {
          navigate(ROUTES.ACCOUNT);
          setCollapsed(true);
          setMobileSidebar(false);
        },
        label: t('layout:account')
      });
    }
  } else {
    if (auth.superAdminToken) {
      links.push({
        key: ROUTES.ACCOUNTS,
        icon: <ShopOutlined />,
        onClick: () => {
          setCollapsed(true);
          setMobileSidebar(false);
          navigate(ROUTES.ACCOUNTS);
        },
        label: t('layout:accounts')
      });

      links.push({
        key: ROUTES.API_KEYS,
        icon: <KeyOutlined />,
        onClick: () => {
          navigate(ROUTES.API_KEYS);
          setCollapsed(true);
          setMobileSidebar(false);
        },
        label: t('layout:api_keys')
      });

      links.push({
        key: ROUTES.PROFILE,
        icon: <SettingOutlined />,
        onClick: () => {
          setCollapsed(true);
          setMobileSidebar(false);
          if (isSuperAdminOnlyLogged) {
            return navigate(`${ROUTES.PROFILE}?account=false`)
          }
          navigate(ROUTES.PROFILE);
        },
        label: t('layout:profile')
      });
    }
  }

  return {
    links
  }
};

export default useLinks;
